import styled from 'styled-components';

export default styled.img`
    animation: fadeIn 200ms linear;
    max-width: 26px;
    min-width: 26px;
    display: block;
`;
